import React, { Fragment, useState, useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Link } from 'react-router-dom'
import { Search } from 'carbon-components-react'
import { PageFirst20, PageLast20 } from '@carbon/icons-react'

import { OverflowMenu } from '../../../OverflowMenu'
import Navigation from '../Navigation'

import './index.scss'

const getFilteredItems = (filter, items) => {
  const matchesSearchTerm = (text = '') =>
    text.toLowerCase().includes(filter.toLowerCase())

  return items.reduce((acc, section) => {
    // Show the entire section if its title contains the searched word
    if (matchesSearchTerm(section.title)) return [...acc, section]

    // If the section title does not contain the searched word, check its sub items
    const filteredSubitems = (section.items || []).filter(({ title }) =>
      matchesSearchTerm(title)
    )

    return filteredSubitems.length > 0
      ? [...acc, { ...section, items: filteredSubitems }]
      : acc
  }, [])
}

export const renderActions = (actions) => (
  <OverflowMenu onClick={(event) => event.stopPropagation()}>
    {actions.map(({ title, onClick }, i) => (
      <OverflowMenu.Item
        key={`action-${i}`}
        itemText={title}
        onClick={(event) => {
          event.stopPropagation()
          onClick && onClick()
        }}
      />
    ))}
  </OverflowMenu>
)

function SideNavbar({
  title,
  showHeader,
  showSidebarSearch,
  isSideNavExpanded,
  onClickSideNavExpand,
  sidebarList,
  sidebarSectionExpanded,
  setSidebarSectionExpanded,
  titleLink,
  actions,
  searchPlaceholder = 'Search',
  searchLabel = 'Search',
  location,
  enableDragAndDrop,
  getMapModelByDragAndDrop
}) {
  const [filter, setFilter] = useState('')
  useEffect(() => {
    setFilter('')
  }, [location])

  const handleChangeFilter = useCallback(
    ({ target: { value } }) => setFilter(value),
    []
  )

  const filteredItems =
    filter.length > 1 ? getFilteredItems(filter, sidebarList) : sidebarList

  return (
    <Fragment>
      {showHeader && (
        <div className='sidebar-head'>
          <span className='sidebar-head__title'>
            {titleLink ? <Link to={titleLink}>{title}</Link> : title}
          </span>
          {actions?.length > 0 && renderActions(actions)}
          <div
            className={cx(
              'sidebar-head__icon',
              'bx--btn',
              'bx--btn--ghost',
              'bx--btn--icon-only'
            )}
            onClick={onClickSideNavExpand}
          >
            {isSideNavExpanded ? <PageFirst20 /> : <PageLast20 />}
          </div>
        </div>
      )}
      {/* add showSearch, increment icon dimension, studiare come fare default chiusa */}
      {showSidebarSearch && isSideNavExpanded && (
        <Search
          className='sidenavbar-search'
          labelText={searchLabel}
          placeHolderText={searchPlaceholder}
          type='text'
          value={filter}
          onChange={handleChangeFilter}
        />
      )}
      <Navigation
        type='sidebar'
        isSideNavExpanded={isSideNavExpanded}
        sidebarSectionExpanded={sidebarSectionExpanded}
        setSidebarSectionExpanded={setSidebarSectionExpanded}
        items={filteredItems}
        enableDragAndDrop={enableDragAndDrop}
        getMapModelByDragAndDrop={getMapModelByDragAndDrop}
      />
    </Fragment>
  )
}

SideNavbar.propTypes = {
  sidebarList: PropTypes.array,
  expanded: PropTypes.bool,
  searchPlaceholder: PropTypes.string,
  searchLabel: PropTypes.string
}

export default SideNavbar
